export default __webpack_public_path__ + "static/media/qr-code-example.b993c1a3.png";